<template>
    <div style="height: calc(100vh - 85px)">
        <iframe id="page_frame" name="page_frame" style="width: 100%; height: 100%; border: none"></iframe>
        <form id="frmLoadPage" :action="action" method="post" target="page_frame">
            <input type="hidden" name="lang" :value="$store.requestParams.lang?.replace('_', '-')" />
            <input type="hidden" name="frame" value="1" />
            <input type="hidden" name="securityToken" :value="$store.requestParams.securityToken" />
        </form>
    </div>
</template>

<script>
    export default {
        name: 'CustomPage',
        computed: {
            action() {
                return this.$store.menuOption?.replace('{server.name}', window.location.host);
            },
        },
        created() {
            window.addEventListener('message', this.receiveMessage, false);

            this.$nextTick(() => {
                document.getElementById('frmLoadPage').submit();
            });
        },
        methods: {
            receiveMessage(event) {
                const type = event.data && event.data.type ? event.data.type : '';
                switch (type) {
                    case 'clearStatusMessage':
                        this.$store.hideStatusMessage();
                        break;
                    case 'displaySuccessMessage':
                        this.$store.showSuccessMessage(event.data.message);
                        break;
                    case 'displayErrorMessage':
                        this.$store.showErrorMessage(event.data.message);
                        break;
                    case 'clearStatusPanel':
                        this.$store.hideLoadingOverlay();
                        break;
                    case 'displayStatusLoading':
                        this.$store.setShowLoadingOverlay('Loading...');
                        break;
                    case 'displayStatusSaving':
                        this.$store.setShowLoadingOverlay('Saving...');
                        break;
                    case 'displayStatusDeleting':
                        this.$store.setShowLoadingOverlay('Deleting...');
                        break;
                }
            },
        },
    };
</script>
